import { render, staticRenderFns } from "./ChangeUserInformation.vue?vue&type=template&id=66f7ec1c&"
import script from "./ChangeUserInformation.vue?vue&type=script&lang=js&"
export * from "./ChangeUserInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports